"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vocabulary = exports.VocabularyProperties = void 0;
var content_1 = require("./content");
var enums_1 = require("./enums");
var vocabulary_term_1 = require("./vocabulary-term");
exports.VocabularyProperties = ['terms'];
var Vocabulary = /** @class */function (_super) {
  __extends(Vocabulary, _super);
  function Vocabulary(values) {
    if (values === void 0) {
      values = {};
    }
    var _this = _super.call(this, values) || this;
    _this.type = enums_1.ContentTypeEnum.vocabulary;
    _this.terms = [];
    var properties = exports.VocabularyProperties;
    var instance = _this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if ('terms' in values) {
      instance.terms = (values.terms || []).map(function (term) {
        return new vocabulary_term_1.VocabularyTerm(term);
      });
    }
    return _this;
  }
  Vocabulary.prototype.getClassProperties = function () {
    return __spreadArray(__spreadArray([], exports.VocabularyProperties, true), _super.prototype.getClassProperties.call(this), true);
  };
  return Vocabulary;
}(content_1.Content);
exports.Vocabulary = Vocabulary;
